import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { HideDialog } from "../../../General/globalFunctions";
import { ExecuteLayoutEventMethods } from "../../../General/commonFunctions";
import PureJSComponentFactory from "../../Pages/Factory/pureJSComponentFactory";

class AppDialog extends Component {
    async firstButtonClick() {
        HideDialog();

        if (this.props.dialogInfo?.btn1?.props?.whenclick)
            await ExecuteLayoutEventMethods(this.props.dialogInfo?.btn1?.props?.whenclick);
    }
    async secondButtonClick() {
        HideDialog();

        if (this.props.dialogInfo?.btn2?.props?.whenclick)
            await ExecuteLayoutEventMethods(this.props.dialogInfo?.btn2?.props?.whenclick);

    }
    onDialogClose() {
        HideDialog();
    }
    render() {

        let scaff = this.props.dialogInfo?.description; 
        if( this.props.dialogInfo?.content) scaff = new PureJSComponentFactory().scaffoldComponent( this.props.dialogInfo?.content, "", (Math.random() * 10000).toFixed());
        return (

            <Dialog open={this.props.dialogInfo?.open} onClose={this.onDialogClose.bind(this)}
                style={{ zIndex: 10000 }} >
                <DialogTitle id="alert-dialog-title">{this.props.dialogInfo?.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {scaff}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {this.props.dialogInfo?.btn1 ?
                        <Button onClick={this.firstButtonClick.bind(this)} color="primary" {...this.props.dialogInfo?.btn1?.props}>
                            {this.props.dialogInfo?.btn1?.chld}
                        </Button>
                        : null}
                    {this.props.dialogInfo?.btn2 ?
                        <Button onClick={this.secondButtonClick.bind(this)} color="primary" autoFocus {...this.props.dialogInfo?.btn2?.props}>
                            {this.props.dialogInfo?.btn2?.chld}
                        </Button>
                        : null
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default AppDialog; 